import React from "react";

import GridColumn, { GridColumnType } from "./GridColumn";
import Checkbox from "../inputform/Checkbox";
import DatePicker from "../inputform/DatePicker";
import Textbox from "../inputform/Textbox";
import DropDown from "../inputform/DropDown";

interface GridFilterCellProps<T> {
    column: GridColumn<T>;
    index: number;
    value: any;
    globalFilter: boolean;

    onClearFilters: () => void;
    filterChanged: (field: string, value: any) => void;
}

interface GridFilterCellState {
    cellRef: React.RefObject<HTMLTableCellElement>;
}

class GridFilterCell<T> extends React.Component<
    GridFilterCellProps<T>,
    GridFilterCellState
> {
    filterable() {
        return this.props.globalFilter || this.props.column.filterable;
    }

    getEditor() {
        switch (this.props.column.type) {
            case GridColumnType.Checkbox:
                return (
                    <Checkbox
                        tristate={true}
                        value={this.props.value}
                        onChange={value =>
                            this.props.filterChanged(
                                this.props.column.field,
                                value,
                            )
                        }
                    />
                );
            case GridColumnType.Number:
                return (
                    <Textbox
                        type="number"
                        value={this.props.value}
                        min={this.props.column.minNumber}
                        max={this.props.column.maxNumber}
                        allowNull={true}
                        decimalPlaces={this.props.column.decimalPlaces}
                        decimalIncrement={this.props.column.decimalIncrement}
                        onChange={value =>
                            this.props.filterChanged(
                                this.props.column.field,
                                value,
                            )
                        }
                    />
                );
            case GridColumnType.Date:
                return (
                    <DatePicker
                        value={this.props.value}
                        onChange={value =>
                            this.props.filterChanged(
                                this.props.column.field,
                                value,
                            )
                        }
                    />
                );
            case GridColumnType.Dropdown:
                return (
                    <DropDown
                        noType={true}
                        blank={true}
                        value={this.props.value}
                        onChange={value =>
                            this.props.filterChanged(
                                this.props.column.field,
                                value,
                            )
                        }
                        options={this.props.column.options ?? []}
                    />
                );
            default:
                return (
                    <Textbox
                        value={this.props.value}
                        onChange={value =>
                            this.props.filterChanged(
                                this.props.column.field,
                                value,
                            )
                        }
                    />
                );
        }
    }

    render(): React.ReactNode {
        let classes = [];

        if (this.props.column.type)
            classes.push(
                GridColumnType[this.props.column.type].toLowerCase(),
            );

        return (
            <th
                className={classes.join(" ")}
                style={{ width: this.props.column.width }}>
                {this.props.index === 0 ? (
                    <button
                        className="filter-icon"
                        data-tip="Temporarily filter columns by entering a filter value in this row, click here to clear"
                        onClick={this.props.onClearFilters}
                    />
                ) : (
                    <label>{this.filterable() ? this.getEditor() : null}</label>
                )}
            </th>
        );
    }
}

export default GridFilterCell;
